import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Touch-friendly textarea component with:
 * - Adequate minimum height for comfortable touch interaction
 * - Larger touch-friendly padding
 * - Proper touch-action for scrolling within textarea
 */

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // Base styles with touch-friendly minimum height (increased from 80px to 100px)
        "flex min-h-[100px] w-full rounded-md border border-input bg-background",
        // Touch-friendly padding (increased py from 2 to 3)
        "px-3 py-3",
        // Typography - base size on mobile for better readability and to prevent iOS zoom
        "text-base md:text-sm",
        // Ring offset for focus
        "ring-offset-background",
        // Placeholder styling
        "placeholder:text-muted-foreground",
        // Focus states
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        // Disabled states
        "disabled:cursor-not-allowed disabled:opacity-50",
        // Touch-friendly enhancements - allow vertical touch scrolling within textarea
        "touch-action-pan-y",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
